"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var http_1 = require("@angular/common/http");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var HttpDocumentManagerClient = /** @class */ (function () {
    function HttpDocumentManagerClient(http, applicationPropertiesService, _currentLanguageProvider) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.serviceUrlKey = 'ejustice-document-service-url';
        this.serviceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.serviceUrlKey));
    }
    HttpDocumentManagerClient.prototype.loadDocumentsByEntityId = function (categoryId, entityId, paging, filter, sorting) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNull(categoryId);
        idm_common_util_frontend_1.PreconditionCheck.notNull(entityId);
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) {
                return {
                    language: language,
                    serviceUrl: serviceUrl
                };
            }));
        }), operators_1.switchMap(function (res) {
            var url = res.serviceUrl + "/documents/" + categoryId + "/" + entityId + "?languageId=" + res.language.getId();
            var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
            var options = { headers: headers };
            return _this.http.post(url, { paging: paging, filter: filter, sorting: sorting }, options);
        }));
    };
    HttpDocumentManagerClient.prototype.loadFolders = function (caseCategoryName) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNull(caseCategoryName);
        return this.serviceUrl$.pipe(operators_1.map(function (serviceUrl) {
            return serviceUrl;
        }), operators_1.switchMap(function (serviceUrl) {
            var url = serviceUrl + "/documents/" + caseCategoryName + "/folders";
            var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
            var options = { headers: headers };
            return _this.http.get(url, options).map(function (response) {
                return Array.from(response);
            });
        }));
    };
    HttpDocumentManagerClient = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpDocumentManagerClient);
    return HttpDocumentManagerClient;
}());
exports.HttpDocumentManagerClient = HttpDocumentManagerClient;
//# sourceMappingURL=http-document-manager.client.js.map